<template>
  <portal-layout>
    <!-- 顶部横幅 -->
    <section class="banner">
      <h1 class="banner-title">小程童信奥</h1>
      <p class="banner-subtitle">专注青少年信息学奥林匹克竞赛教学与训练</p>
      <div class="banner-actions">
        <el-button type="primary" size="medium" class="banner-shop-btn" @click="goShopList">浏览课程商城</el-button>
        <el-button size="medium" class="banner-site-btn" @click="goSite">访问官网</el-button>
      </div>
    </section>

    <!-- 功能卡片 -->
    <section class="card-section">
      <div class="card-item" @click="goShopList">
        <i class="el-icon-goods card-icon"></i>
        <h3 class="card-title">课程商城</h3>
        <p class="card-desc">浏览直播与录播课程，在线收藏与加购</p>
      </div>
      <div class="card-item" @click="goReport">
        <i class="el-icon-data-line card-icon"></i>
        <h3 class="card-title">学习报告</h3>
        <p class="card-desc">查看课程安排与学习进度，掌握学习情况</p>
      </div>
      <div class="card-item" @click="goExam">
        <i class="el-icon-edit-outline card-icon"></i>
        <h3 class="card-title">在线考试</h3>
        <p class="card-desc">参与信息学竞赛模拟考试，检验学习成果</p>
      </div>
      <div class="card-item" @click="goSite">
        <i class="el-icon-link card-icon"></i>
        <h3 class="card-title">官方网站</h3>
        <p class="card-desc">查看机构介绍、课程服务与最新动态</p>
      </div>
    </section>

    <!-- 考试预告 -->
    <section class="exam-section">
      <div class="section-header">
        <h2 class="section-title">近期考试</h2>
        <el-button type="text" @click="goExam">查看全部 <i class="el-icon-arrow-right"></i></el-button>
      </div>
      <div v-loading="loading" class="exam-list">
        <div v-if="!loading && exams.length === 0" class="empty-tip">暂无考试安排</div>
        <div v-for="exam in exams.slice(0, 3)" :key="exam.id" class="exam-item">
          <div class="exam-info">
            <h4 class="exam-name">{{ exam.examName }}</h4>
            <p class="exam-desc">{{ exam.examDesc }}</p>
            <p class="exam-time">
              <i class="el-icon-time"></i>
              {{ exam.startTime }} 至 {{ exam.endTime }}
            </p>
          </div>
          <div class="exam-action">
            <el-tag :type="statusTagType(exam.myStatus)" size="small">{{ statusText(exam.myStatus) }}</el-tag>
            <el-button type="primary" size="small" @click="goExam">去考试</el-button>
          </div>
        </div>
      </div>
    </section>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import api from '@/common/api';
import storage from '@/common/storage.js';
export default {
  name: 'PortalHome',
  components: { PortalLayout },
  data() {
    return {
      loading: false,
      exams: []
    }
  },
  created() {
    this.queryExams();
  },
  methods: {
    goExam() {
      // 已在考试列表页时不重复跳转，避免 NavigationDuplicated
      if (this.$route.path === '/portal/customize/exam') return;
      // 未登录时直接跳登录页，并指定登录后回跳在线考试列表
      if (!storage.getString('portalMember')) {
        this.$router.push({ name: 'PortalLogin', query: { redirect: '/portal/customize/exam' } }).catch(() => {});
        return;
      }
      this.$router.push('/portal/customize/exam').catch(() => {});
    },
    // 课程商城允许匿名浏览
    goShopList() {
      this.$router.push('/portal/shop/list').catch(() => {});
    },
    goReport() {
      // 学习报告需登录，未登录时先跳登录页并回跳
      if (!storage.getString('portalMember')) {
        this.$router.push({ name: 'PortalLogin', query: { redirect: '/portal/report/list' } }).catch(() => {});
        return;
      }
      this.$router.push('/portal/report/list').catch(() => {});
    },
    queryExams() {
      this.loading = true;
      // silent: 门户首页允许匿名浏览，未登录(401)时不跳登录页，仅不展示考试列表
      api.hoj_customize_exam_list({ silent: true }).then((r) => {
        if (r.data.code === "200") {
          // 后端 R.ok(List) 把列表放在 rows 字段(data 为对象时才有值)，做兼容兜底
          this.exams = r.data.rows || r.data.data || [];
        }
      }).catch(() => {
        // 未登录时不展示考试列表
      }).finally(() => {
        this.loading = false;
      });
    },
    statusText(status) {
      const map = { '0': '未参加', '1': '进行中', '2': '已提交' };
      return map[status] || '未参加';
    },
    statusTagType(status) {
      const map = { '0': 'info', '1': 'warning', '2': 'success' };
      return map[status] || 'info';
    },
    // 打开官网静态站点(public/site)，新窗口
    goSite() {
      window.open('/site/index.html', '_blank');
    }
  }
};
</script>
<style scoped>
/* ---------- 顶部横幅 ---------- */
.banner {
  position: relative;
  overflow: hidden;
  background: linear-gradient(120deg, #1E6AD8 0%, #2B7EF5 45%, #4A91F7 100%);
  border-radius: 14px;
  padding: 64px 40px;
  text-align: center;
  color: #fff;
  margin-bottom: 28px;
  box-shadow: 0 8px 28px rgba(43, 126, 245, 0.24);
}
/* 右侧暖色光晕，破掉整块冷蓝的单薄感 */
.banner::after {
  content: '';
  position: absolute;
  right: -80px;
  top: -80px;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 138, 71, 0.42) 0%, rgba(255, 138, 71, 0) 68%);
  pointer-events: none;
}
.banner-title {
  position: relative;
  font-size: 38px;
  font-weight: 700;
  letter-spacing: 1px;
  margin: 0 0 16px 0;
}
.banner-subtitle {
  position: relative;
  font-size: 16px;
  margin: 0 0 32px 0;
  opacity: 0.92;
}
.banner-actions {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
.banner-shop-btn {
  padding: 12px 32px;
  font-size: 15px;
  background-color: #fff;
  border-color: #fff;
  color: #1E6AD8;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
}
.banner-shop-btn:hover,
.banner-shop-btn:focus {
  background-color: #F0F6FF;
  border-color: #F0F6FF;
  color: #1E6AD8;
}
.banner-site-btn {
  padding: 12px 32px;
  font-size: 15px;
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.65);
  color: #fff;
}
.banner-site-btn:hover,
.banner-site-btn:focus {
  background-color: rgba(255, 255, 255, 0.16);
  border-color: #fff;
  color: #fff;
}

/* ---------- 功能卡片 ---------- */
.card-section {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
.card-item {
  flex: 1;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #EEF1F6;
  padding: 32px 22px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease;
  box-shadow: 0 1px 3px rgba(31, 39, 51, 0.04), 0 4px 12px rgba(31, 39, 51, 0.05);
}
.card-item::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: linear-gradient(90deg, #2B7EF5 0%, #FF8A47 100%);
  transform: scaleX(0);
  transition: transform 0.28s ease;
}
.card-item:hover {
  transform: translateY(-6px);
  border-color: #D8E5FA;
  box-shadow: 0 4px 12px rgba(31, 39, 51, 0.08), 0 14px 32px rgba(31, 39, 51, 0.1);
}
.card-item:hover::after {
  transform: scaleX(1);
}
.card-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 16px;
  font-size: 27px;
  color: #2B7EF5;
  background-color: #EAF3FE;
  transition: all 0.28s ease;
}
.card-item:hover .card-icon {
  background-color: #2B7EF5;
  color: #fff;
}
.card-title {
  font-size: 17px;
  font-weight: 600;
  color: #1F2733;
  margin: 18px 0 10px 0;
}
.card-desc {
  font-size: 13px;
  color: #78838F;
  margin: 0;
  line-height: 1.65;
}

/* ---------- 考试预告 ---------- */
.exam-section {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #EEF1F6;
  padding: 24px 26px;
  box-shadow: 0 1px 3px rgba(31, 39, 51, 0.04), 0 4px 12px rgba(31, 39, 51, 0.05);
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid #EEF1F6;
}
.section-title {
  position: relative;
  font-size: 18px;
  font-weight: 600;
  color: #1F2733;
  margin: 0;
  padding-left: 12px;
  line-height: 22px;
}
.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 2px;
  bottom: 2px;
  width: 4px;
  border-radius: 2px;
  background: linear-gradient(180deg, #2B7EF5 0%, #FF8A47 100%);
}
.exam-list {
  min-height: 100px;
}
.empty-tip {
  text-align: center;
  color: #A8B0BA;
  padding: 48px 0;
  font-size: 14px;
}
.exam-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;
  border-bottom: 1px solid #F2F5F9;
  transition: background-color 0.25s ease;
}
.exam-item:last-child {
  border-bottom: none;
}
.exam-info {
  flex: 1;
  min-width: 0;
}
.exam-name {
  font-size: 16px;
  font-weight: 600;
  color: #1F2733;
  margin: 0 0 8px 0;
}
.exam-desc {
  font-size: 13px;
  color: #4A5568;
  margin: 0 0 8px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.exam-time {
  font-size: 12px;
  color: #78838F;
  margin: 0;
}
.exam-time i {
  color: #2B7EF5;
  margin-right: 4px;
}
.exam-action {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  padding-left: 20px;
}

/* ---------- 窄屏 ---------- */
@media (max-width: 900px) {
  .banner {
    padding: 44px 22px;
  }
  .banner-title {
    font-size: 28px;
  }
  .card-section {
    flex-wrap: wrap;
  }
  .card-item {
    flex: none;
    width: calc((100% - 20px) / 2);
  }
  .exam-item {
    flex-direction: column;
    align-items: flex-start;
  }
  .exam-action {
    padding: 12px 0 0 0;
  }
}
</style>
